/**
 * @class {SectionGiftQuiz}
 * @extends {Section}
 */
const SectionGiftQuiz = Class(
	/**
	 * @lends {SectionGiftQuiz#}
	 */
	{
		__NAME: 'SectionGiftQuiz',

		bodyClass: 'small-nav small-nav-permanent gift-quiz-page',

		gifts: {
			expert: [
				'skull',
				'headphones',
				'mask',
				'crown'
			],
			hunter: [
				'coins',
				'log'
			],
			groupie: [
				'mirror',
				'courses',
				'beauty',
				'capsules'
			],
			"g-spot": [
				'services',
				'glasses',
				'drink',
				'room'
			],
			explorer: [
				'steam',
				'ladder',
				'paste'
			],
			detective: [
				'shovel',
				'arms'
			],
			matchmaker: [
				'nose',
				'zoom',
				'light'
			],
			sprinter: [
				'sole',
				'drone'
			]
		},

		route() {
			let part = this.url.shift();
			switch(part) {
				case 'questions':
					return new SectionGiftQuiz.Questions;
				case 'results':
					return new SectionGiftQuiz.Results;
				default:
					return new SectionGiftQuiz.Home;
			}
		}
	},
	Section
);
